module.exports = __webpack_public_path__ + "static/uber_737x920-593814f47aa7bff497bfba5c994ffcf5.png";